<div>
  <h4>Backup mode for this DynamoDB table needs to be configured.</h4>
</div>
<div class="margin-top">
  {{ uiService.productName }} needs to know whether to replicate this table's data or protect its structure only.
</div>
<form [formGroup]="backupModeFormModel" (ngSubmit)="saveClick()" class="form-controls">
  <div>
    <div class="control-header-with-instructions">
      <h4 class="spacer">How should {{ uiService.productName }} protect this table?</h4>
    </div>
    <div class="arpio-radio-container">
      <div class="margin-top"></div>
      <label class="arpio-radio">
        <input id="backup-mode-data" type="radio" formControlName="backupMode" [value]="DynamoDbBackupMode.data" />
        <span class="radio-label strong-text"> Protect the table and its data</span>
        <div>
          Choose this option when your application needs this table's data after recovery.
          {{ uiService.productName }} will replicate the table's data continuously and recreate the table with that data
          in the recovery environment. This table must have DynamoDB Streams enabled.
        </div>
      </label>
      <div class="margin-top"></div>
      <label class="arpio-radio">
        <input
          id="backup-mode-metadata-only"
          type="radio"
          formControlName="backupMode"
          [value]="DynamoDbBackupMode.metadataOnly"
        />
        <span class="radio-label strong-text"> Protect the table's structure only</span>
        <div>
          Choose this option for tables your application can repopulate after recovery, such as caches or derived data.
          {{ uiService.productName }} will recreate the table's schema, indexes, and settings in the recovery
          environment. The table starts empty. No streams required, no data replicated.
        </div>
      </label>
    </div>
  </div>
  <div class="flex-center-row control-header">
    <div class="spacer"></div>
    <button id="save-button" type="submit" class="arpio-button" [disabled]="!validConfig || saving">
      @switch (saveStatus) {
        @case ('saving') {
          <svg lucideLoaderCircle class="lucide-spin"></svg>
        }
        @case ('saved') {
          <svg lucideCheck></svg>
        }
        @default {
          Save
        }
      }
    </button>
  </div>
</form>
